<template xmlns:el-table="http://www.w3.org/1999/html">
  <div class="row">
    <!-- 标题-副标题 -->
    <div class="col-md-12">
      <h4 class="title">{{title}}</h4>
    </div>
    <div class="col-md-12 card">
      <div class="card-header">
      </div>

      <div class="card-body row">
        <!-- 分页 -->
        <div class="col-sm-6">
          <el-select
            class="select-default"
            style="width: 5.5em"
            v-model="pagination.perPage"
            placeholder="Per page">
            <el-option
              class="select-default"
              v-for="item in pagination.perPageOptions"
              :key="item"
              :label="item"
              :value="item">
            </el-option>
          </el-select>
          &nbsp;
          <div style="display: inline-block">
            <el-select
              class="el-select"
              style="width: 7.8em"
              v-model="currentsearchType"
              placeholder="Per page">
              <!--              <el-option-->
              <!--                class="select-default"-->
              <!--                v-for="item in searchType"-->
              <!--                :key="item"-->
              <!--                :label="item"-->
              <!--                :value="item">-->
              <!--              </el-option>-->
            </el-select>
          </div>
          <div style="display:inline-block">
            <fg-input class="input-sm"
                      placeholder="搜索"
                      v-model="searchQuery"
                      @keyup.enter="getData">
            </fg-input>
          </div>
          <p-button @click="getData">搜索</p-button>
        </div>

        <!--搜索 -->
        <div class="col-sm-6">

          <div class="pull-right">
            <el-switch
              style="display: block"
              v-model="is_all"
              active-color="#13ce66"
              inactive-color="#ff4949"
              active-text="显示个人记录"
              inactive-text="显示全部记录">
            </el-switch>
            <p-button type="info" plain @click="cractAccount">
              上传母包
            </p-button>
          </div>
        </div>


        <!-- 表格 -->
        <div class="col-sm-12 mt-2">
          <el-table class="table-striped"
                    :data="queriedData"
                    border
                    style="width: 100%">
            <el-table-column type="selection" v-model="course">
            </el-table-column>
            <el-table-column v-for="column in tableColumns"
                             :key="column.label"
                             :min-width="column.minWidth"
                             :prop="column.prop"
                             :label="column.label">
            </el-table-column>
            <el-table-column
              :min-width="220"
              fixed="right"
              class-name="td-actions"
              label="操作">
              <template slot-scope="props">
                <p-button type="danger" size="sm" @click="reloadapk(props.$index, props.row)">
                  <i>重新上传母包</i>
                </p-button>
                <p-button type="danger" size="sm" @click="handleDelete(props.$index, props.row)">
                  <i>删除母包</i>
                </p-button>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <!-- 底部 -->
        <div class="col-sm-6 pagination-info">
          <p class="category">{{page}}</p>
        </div>
        <div class="col-sm-6">
          <p-pagination class="pull-right"
                        v-model="pagination.currentPage"
                        :page-count="pagination.page_count">
          </p-pagination>
        </div>
      </div>
    </div>

    <el-dialog title="重新上传母包" :visible.sync="dialogreloadAPklVisible">

      <!--      <fg-input v-model="apk_version" placeholder="请输入母包版本号" label="版本号"></fg-input>-->
      <el-upload
        class="upload-file"
        ref="apk"
        :action="fileUploadUrl"
        :headers="getToken"
        :limit="1"
        name="apkfile"
        :data="postData"
        :on-success="handleAvatarSuccess"
        :on-progress="handleProgress"
        :on-change="resourceChange"
        :file-list="resoucreList"
        :auto-upload="false">
        <div slot="tip" class="el-upload__tip">上传母包,母包必须以".apk"结尾</div>
        <el-button slot="trigger" size="small" type="primary" @click="reloadfile">选取文件</el-button>
        <el-button style="margin-left: 10px;" size="small" type="success" @click="submitUpload">上传到服务器
        </el-button>
      </el-upload>
      <div slot="footer" class="dialog-footer">
        <div class="btn-group">
          <p-button type="info" round outline v-on:click="dialogreloadAPklVisible=false">取 消</p-button>
          <!--          <p-button type="info" round @click="editorchannelhandle">确 定</p-button>-->
        </div>
      </div>
    </el-dialog>

    <el-dialog title="上传母包" :visible.sync="dialogupApkVisible">
      <fg-input v-model="alias" placeholder="请输入母包名" label="母包名"></fg-input>
      <!--      <fg-input v-model="apk_version" placeholder="请输入母包版本如1.4.3" label="母包版本"></fg-input>-->
      <el-upload
        class="upload-file"
        ref="apk"
        :action="fileUploadUrl"
        :headers="getToken"
        :limit="1"
        name="apkfile"
        :data="postData"
        :on-success="handleAvatarSuccess"
        :on-progress="handleProgress"
        :on-change="resourceChange"
        :file-list="resoucreList"
        :auto-upload="false">
        <div slot="tip" class="el-upload__tip">上传母包,母包必须以".apk"结尾</div>
        <el-button slot="trigger" size="small" type="primary" @click="addfile">选取文件</el-button>
        <el-button style="margin-left: 10px;" size="small" type="success" @click="submitUpload">上传到服务器
        </el-button>
      </el-upload>
      <div slot="footer" class="dialog-footer">
        <div class="btn-group">
          <p-button type="info" round outline @click="dialogupApkVisible=false">取 消</p-button>
          <!--          <p-button type="info" round @click="cractAccountSubmit">确 定</p-button>-->
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import Vue from 'vue'
  import swal from 'sweetalert2'
  import {Table, TableColumn, Select, Option} from 'element-ui'
  import PPagination from 'src/components/UIComponents/Pagination.vue'
  import Search from 'src/components/UIComponents/Search/Search.vue'
  import {getFetch} from 'src/util/fetch'
  import {Cookie} from 'src/util/cookie'
  import PButton from "../../../UIComponents/Button";

  Vue.use(Table)
  Vue.use(TableColumn)
  Vue.use(Select)
  Vue.use(Option)
  export default {
    watch: {
      'pagination.perPage'() {
        this.getData()
      },
      'pagination.currentPage'() {
        this.getData()
      },
      is_all(){
        this.getData();
      },
    },
    components: {
      PButton,
      PPagination,
      Search,
    },
    computed: {
      channelArgsData() {
        return this.channelArgstableData
      },
      ArgsData() {
        return this.channelArgsAlone

      },
      queriedData() {
        return this.tableData
      },
      to() {
        let highBound = this.from + this.pagination.perPage
        if (this.total < highBound) {
          highBound = this.total
        }
        return highBound
      },
      from() {
        return this.pagination.perPage * (this.pagination.currentPage - 1)
      },
      total() {
        // this.changeTotal(this.total_count)
        return this.total_count
      },
      page() {
        return `从 ${this.from + 1} 到 ${this.to} 共 ${this.total} 条`
      },

    },
    data() {//定义tabel
      return {
        is_all:false,
        postData: {},
        floor: "yypt",
        fileUploadUrl: window.Config.host + '/api/games/apkinfo/',
        resoucreList: [],
        title: '母包列表',
        dialogFile: "",
        dialogreloadAPklVisible: false,
        dialogupApkVisible: false,

        pagination: {//分页
          perPage: 30,
          currentPage: 1,
          perPageOptions: [5, 10, 25, 50],
          page_count: 0,
          total: 0
        },
        alias: '',
        apk_version: '',
        reloadobj: {},
        isreload: false,
        fileList: [],
        editorobj: [],
        searchQuery: '',//搜索值
        getToken: {
          token: '',
        },
        currentsearchType: '母包名',
        searchType: ['母包名'],//搜索字段
        tableColumns: [//列表
          {
            prop: 'alias',
            label: '母包名称',
            minWidth: 100
          },
          {
            prop: 'father_path',
            label: '母包地址',
            minWidth: 200
          },
          {
            prop: 'up_time',
            label: '母包上传时间',
            minWidth: 150
          },
          {
            prop: 'apk_version',
            label: '母包版本',
            minWidth: 80
          },
          {
            prop: 'uid',
            label: '上传者',
            minWidth: 100
          }
        ],
        tableData: [],//渲染table数据

        //获取游戏信息批量传输给后台
        course: [],
        total_count: 0,

      }
    },
    methods: {
      addfile() {
        this.isreload = false
      },
      reloadfile() {
        this.isreload = true
      },
      addData() {
        this.getMyToken()
        this.postData = {
          alias: this.alias,
          floor: this.floor,
          // apk_version: this.apk_version,
        }

      },
      editorData() {
        this.getMyToken()
        this.postData = {
          apkid: this.reloadobj.id,
          floor: this.floor,
          // apk_version: this.apk_version

        }
      },
      checkfile(file, filelist) {
        for (let i = 0; i < filelist.length; i++) {
          if (filelist[i].name === file.name) {
            filelist.splice(i, 1)
          }
        }
      },
      resourceChange(file, fileList) {
        if (file.name.endsWith(".apk")) {
          this.dialogFile = file.raw;
        } else {
          alert("文件格式错误")
          this.checkfile(file, fileList)
        }
      },
      handleAvatarSuccess() {
        this.resoucreList = [];
        this.dialogFile = "";
        this.dialogupApkVisible = false;
        this.dialogreloadAPklVisible = false;
        this.cleanData()
        this.getData(this.pagination.perPage, this.pagination.currentPage)
        //清除属性
        swal({
          title: '上传成功!',
          type: 'success',
          confirmButtonClass: 'btn btn-success btn-fill',
          buttonsStyling: false
        })

      },
      cleanData() {
        this.alias = ''
        this.apk_version = ''
      },
      //查看渠道对应的渠道参数
      // channelArgs(cid) {
      //   this.dialogChannelArgsVisible = true
      //   this.getChannelArgs(cid)
      //   this.channelID = cid
      // },

      handleProgress(event, file, fileList) {


      },
      getMyToken() {
        this.getToken.token = Cookie().get("token")
      },
      cractAccount() {
        this.dialogupApkVisible = true
      },
      reloadapk(index, row) {
        this.dialogreloadAPklVisible = true
        this.apkInfo(index, row)
      },
      //编辑数组对象
      apkInfo(index, row) {
        this.reloadobj = row
        this.editorobj = [row]
      },
      changeTotal(length) {
        this.pagination.total = length
      },
      handleChange(file, fileList) {
        //console.log(file)
        //console.log(fileList)
      },
      async submitUpload() {
        var flag = false
        if (this.isreload) {
          this.editorData()
          flag = true

        } else {
          this.addData()
          if (this.postData.alias) {
            flag = true
          }
        }
        if (flag) {
          setTimeout(() => {
            this.$refs.apk.submit()
          }, 1000);
        } else {
          alert("请先填写相关参数和选择母包再上传!")
        }
      },
      // 缺少正在上传文件的状态处理
      async getData(page, size) {
        page = this.pagination.currentPage
        size = this.pagination.perPage

        let req_data = {}
        req_data["is_all"] = this.is_all ? 0 : 1;
        req_data['size'] = size
        req_data['page'] = page
        req_data['floor'] = this.floor
        if (this.searchQuery !== '') {
          if (this.currentsearchType === this.searchType[0]) {
            req_data['type'] = 1
            req_data['alias'] = this.searchQuery
          }


        }

        let opt = {
          url: '/api/games/apkinfo/',
          type: 'GET',
          data: req_data,

        }
        const res = await getFetch(this, opt);
        if (res.code === 0) {
          let temp = res.data.apks.results
          //console.log(temp)
          for (let i = 0; i < temp.length; i++) {
            if (temp[i].father_path == 0) {
              temp[i].father_path = "后台处理文件ing,请稍后"
            }
          }
          this.tableData = temp
          this.changeTotal(res.data.apks.total_count)
          this.total_count = res.data.apks.total_count
          this.pagination.page_count = res.data.apks.total_page
        }
      },
      //删除渠道
      async handleDelete(index, row) {
        swal({
          title: '确定要这个母包？',
          type: 'warning',
          showCancelButton: true,
          confirmButtonClass: 'btn btn-success btn-fill',
          cancelButtonClass: 'btn btn-danger btn-fill',
          confirmButtonText: '是',
          cancelButtonText: '否',
          buttonsStyling: false
        }).then(() => {
          this.doDelete(index, row)
        })
      },
      async doDelete(index, row) {
        let opt = {
          url: '/api/games/apkinfo/',
          type: 'DELETE',
          data: {
            apkid: row.id,
            floor: this.floor
          }
        }
        const res = await getFetch(this, opt);
        if (res.code == 0) {
          swal({
            title: '删除成功!',
            type: 'success',
            confirmButtonClass: 'btn btn-success btn-fill',
            buttonsStyling: false
          })
          this.getData(this.pagination.perPage, this.pagination.currentPage)
        }
      },

    },
    mounted() {
      this.getData();
    }
  }
</script>

